// utility method used by the media type filter dropdown
export const getMediaTypes = data => {
  const mediaTypes = new Set(data.map(item => item?.view?.mediaType).filter(item => !!item));
  return Array.from(mediaTypes).sort();
};
